<template lang="pug">
    b-container(fluid='')
        template(v-if="showPage && appLoaded")
            b-row.mb-3
                b-col
                    b-button(ref="btn_top_submit" variant="primary" @click="submit_app" :disabled="submit_disabled" v-focus="true")
                        | Submit Application

                b-col
                    b-btn(variant="primary" class="float-right" @click="cancel")
                        | {{ close_button }}
            b-row.mb-0
                b-col.mb-0
                    p.mb-0
                        |Fields marked with an
                        span.requiredField
                            |  *
                        |  are required.
            b-card(no-body)
                big
                    b
                        b-nav#nav-links(pills v-b-scrollspy="'#nav-scroller'")
                            b-nav-item(@click="scrollIntoView" href='#name-contact' v-if="show_section('name_contact')") Name/Contact
                            b-nav-item(@click="scrollIntoView" href='#demographic' v-if="show_section('demographic')") Demographic
                            b-nav-item(@click="scrollIntoView" href='#parent' v-if="show_section('parent')") Parent
                            b-nav-item(@click="scrollIntoView" href='#academic' v-if="show_section('academic')") Academic
                            b-nav-item(@click="scrollIntoView" href='#essay-resume' v-if="show_section('essay_resume')") Essay/Resume
                            b-nav-item(@click="scrollIntoView" href='#activities' v-if="show_section('activities')") Activities
                            b-nav-item-dropdown(text="Campuses" right-aligment)
                                b-dropdown-item(@click="scrollIntoView" href='#uma' v-if="show_campus_section('UMA')") UMA
                                b-dropdown-item(@click="scrollIntoView" href='#um' v-if="show_campus_section('UM')") UM
                                b-dropdown-item(@click="scrollIntoView" href='#umf' v-if="show_campus_section('UMF')") UMF
                                b-dropdown-item(@click="scrollIntoView" href='#umfk' v-if="show_campus_section('UMFK')") UMFK
                                b-dropdown-item(@click="scrollIntoView" href='#umpi' v-if="show_campus_section('UMPI')") UMPI
                                b-dropdown-item(@click="scrollIntoView" href='#umm' v-if="show_campus_section('UMM')") UMM
                                b-dropdown-item(@click="scrollIntoView" href='#usm' v-if="show_campus_section('USM')") USM
                b-card-body#nav-scroller(ref="content" style="position:relative; height:1000px; overflow-y:scroll;")
                    div#main-content
                    div(v-if="show_section('name_contact')")
                        h2#name-contact Name/Contact
                        p#name-contact-content
                            include application/name-contact.pug
                    div(v-if="show_section('demographic')")
                        h2#demographic Demographic
                        p#demographic-content
                            include application/demographic.pug
                    div(v-if="show_section('parent')")
                        h2#parent Parent
                        p#parent-content
                            include application/parent.pug
                    div(v-if="show_section('academic')")
                        h2#academic Academic
                        p#academic-content
                            include application/academic.pug
                    div(v-if="show_section('essay_resume')")
                        h2#essay-resume Essay/Resume
                        p#essay-resume-content
                            include application/essay-resume.pug
                    div(v-if="show_section('activities')")
                        h2#activities Activities
                        p#activities-content
                            include application/activities.pug
                    div(v-if="show_campus_section('UMA')")
                        h2#uma University of Maine at Augusta
                        p#uma-content
                            include application/uma.pug
                    div(v-if="show_campus_section('UM')")
                        h2#um University of Maine
                        p#um-content
                            include application/um.pug
                    div(v-if="show_campus_section('UMF')")
                        h2#umf University of Maine at Farmington
                        p#umf-content
                            include application/umf.pug
                    div(v-if="show_campus_section('UMM')")
                        h2#umm University of Maine at Machias
                        p#umm-content
                            include application/umm.pug
                    div(v-if="show_campus_section('UMPI')")
                        h2#umpi University of Maine at Presque Isle
                        p#umpi-content
                            include application/umpi.pug
                    div(v-if="show_campus_section('UMFK')")
                        h2#umfk University of Maine at Fort Kent
                        p#umfk-content
                            include application/umfk.pug
                    div(v-if="show_campus_section('USM')")
                        h2#usm University of Southern Maine
                        p#usm-content
                            include application/usm.pug
            b-row.mt-3
                b-col
                    b-button(variant="primary" @click="submit_app" :disabled="submit_disabled")
                        | Submit Application

                b-col
                    b-btn(variant="primary" class="float-right" @click="cancel")
                        | {{ close_button }}
        div(v-if="showPage && !appLoaded")
            spinner(ref="spinLoad" message="Please wait while we load your application")
        spinner(ref="spin" message="Please wait while we verify the information that you have submitted.")
        b-modal(
        id="submitted_info"
        ref="modal_submitted_info"
        hide-footer
        no-close-on-backdrop=true
        no-close-on-esc=true
        ok-disabled=true
        cancel-disabled=true
        lazy
        )
            div
                big Affirmation
                p
                    |By clicking CONTINUE, I certify that all information submitted in the admission process -- including this application and any other supporting materials -- is my own work, factually true, and honestly presented, and that these documents will become the property of the institution to which I am applying and will not be returned to me. I understand that I may be subject to a range of possible disciplinary actions, including admission revocation, expulsion, or revocation of course credit, grades, and degree should the information I have certified be false.
                big University of Maine System Policy:
                p.
                    #[strong Maine State Law] requires that all full-time and degree-seeking part-time students born after 1956 show proof of adequate immunization against measles(rubeola), rubella, diphtheria, mumps and tetanus. Students will be notified by the campus they plan to attend concerning required documentation.
                p.
                    #[strong Americans with Disabilities Act] University of Maine System campuses are prepared to assist students with disabilities. If you have a disability and would appreciate help in eliminating a barrier to your admission or subsequent campus experience, please write or call the campus admissions office to which you are applying.
                p.
                    #[strong Equal Opportunity Policy] In complying with the letter and spirit of applicable laws and in pursuing its own goals of pluralism, the University of Maine System will not discriminate on the grounds of race, color, religion, sex, sexual orientation, national origin or citizenship status, age, disability or veterans status in employment, education and all other areas of the University System. The University System provides reasonable accommodations to qualified individuals with disabilities upon request. All universities within the University of Maine System are authorized under Federal law to enroll nonimmigrant alien students.
                p.
                    #[strong Campus Security] A recent change in a federal law, The Clery Act, requires universities to disclose three-year statistics regarding campus crime, including public property within or immediately adjacent to and accessible from the campus. This report includes policies for campus security, such as those concerning alcohol and drug use, crime prevention, the reporting of crimes, sexual assault, and other matters. You can obtain a copy of this report by accessing the appropriate web site at each campus, or obtain a paper copy upon request by contacting the Director of Public Safety at each of the seven University of Maine campuses.
                p.
                    #[strong The University of Maine System] complies with Title IX of the Education Amendments(1972), Title VI of the Civil Rights Act(1964), Section 504 of the Rehabilitation Act(1973), and the Americans with Disabilities Act of 1990.
            div.mt-3
                b-btn(variant="primary" @click="post_submit_info_viewed")
                    |Continue
</template>

<script>
import spinner from "../spinner";
import q_text from "../baseQuestion/text";
import q_static_ddl from "../baseQuestion/staticDDL";
import q_dynamic_ddl from "../baseQuestion/dynamicDDL";
import q_checkbox from "../baseQuestion/checkbox";
import q_file from "../baseQuestion/file";
import q_searchable_ddl from "../baseQuestion/searchableDDL";
import q_multi_field from "../baseQuestion/multiField";
import q_textarea from "../baseQuestion/textarea";
import q_date from "../baseQuestion/date";
import q_searchable_static_ddl from "../baseQuestion/searchableStaticDDL";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			submit_disabled_val: false,
			close_button: "",
			sections: {
				name_contact: "q_first_name",
				demographic: "q_date_of_birth",
				parent: "q_parent_first_name",
				academic: "q_high_school_name",
				essay_resume: "q_essay",
				activities: "q_community"
			}
		};
	},
	components: {
		spinner,
		q_text,
		q_static_ddl,
		q_dynamic_ddl,
		q_checkbox,
		q_file,
		q_searchable_ddl,
		q_multi_field,
		q_textarea,
		q_date,
		q_searchable_static_ddl
	},
	computed: {
		...mapGetters([
			"active_application",
			"active_application_id",
			"userType",
			"application_status",
			"alerts"
		]),
		submit_disabled: {
			get: function() {
				return this.submit_disabled_val;
			},
			set: function(val) {
				this.submit_disabled_val = val;
				this.$refs.spin.set_state(val);
			}
		},
		showPage() {
			return this.active_application !== null;
		},
		appLoaded() {
			return this.application_status === "loaded";
		}
	},
	methods: {
		submit_app() {
			this.submit_disabled = true;
			let v = this;
			this.$nextTick(function() {
				v.$store.dispatch("submit_application");
			});
			this.$refs.btn_top_submit.focus();
		},
		show_campus_section(campus) {
			if (this.active_application && this.active_application.campuses) {
				return this.active_application.campuses.indexOf(campus) !== -1;
			}
			if (this.active_application && this.active_application.institutions) {
				return this.active_application.institutions.indexOf(campus) !== -1;
			}
			return false;
		},
		show_section(section) {
			return this.$store.getters[this.sections[section] + "/is_displayed"];
		},
		scrollIntoView(evt) {
			evt.preventDefault();
			const href = evt.target.getAttribute("href");
			const el = href ? document.querySelector(href) : null;
			if (el) {
				this.$refs.content.scrollTop = el.offsetTop;
			}

			const tag = href + "-content";
			let content_el = null;
			if (href) {
				content_el = document.querySelector(
					(tag + " input, " + tag + " select, " + tag + " textarea ").toString()
				);
			}
			if (content_el) {
				content_el.focus();
			}
		},
		cancel() {
			this.$store.commit("clear_alerts");
			if (this.userType === "guest") {
				this.$router.push("/intro");
			} else {
				this.$router.push("/applications");
			}
		},
		post_submit_info_viewed() {
			this.$router.push("/app-submitted");
		}
	},
	watch: {
		active_application(newState) {
			if (newState === null) {
				this.$router.push("/applications");
			}
		},
		userType(newState) {
			if (newState !== "authed") {
				this.$router.push("/intro");
			}
		},
		application_status(newState) {
			if (newState === "submitted") {
				this.$refs.modal_submitted_info.show();
			} else if (newState === "loaded") {
				this.$refs.spinLoad.hide_modal();
			}
		},
		alerts() {
			this.submit_disabled = false;
		}
	},
	created() {
		if (this.showPage) {
			if (this.userType === "guest") {
				this.close_button = "Start Over";
			} else {
				this.close_button = "Save and Close";
			}
			this.$store.dispatch("get_application_data", this.active_application_id);
		} else {
			this.$router.push("/applications");
		}
	},
	mounted() {
		this.$refs.spinLoad.show_modal();
	},
	beforeDestroy() {
		if (this.application_status !== "submitted") {
			this.$store.commit("set_active_application", null);
			this.$store.commit("set_application_status", null);
		}
	}
};
</script>

<style scoped></style>
